import React from "react";
import { Helmet } from "react-helmet-async";
import {
    DEFAULT_DESCRIPTION,
    DEFAULT_OG_IMAGE,
    SEO_KEYWORDS,
    SITE_NAME,
    SITE_URL,
} from "../../seo/constants";

/**
 * Per-page meta tags for crawlers and social sharing.
 */
const SEO = ({
    title,
    description = DEFAULT_DESCRIPTION,
    path = "",
    image = DEFAULT_OG_IMAGE,
    type = "website",
    noindex = false,
    keywords = SEO_KEYWORDS,
    jsonLd = null,
}) => {
    const fullTitle = title?.includes(SITE_NAME)
        ? title
        : `${title} | ${SITE_NAME}`;
    const canonical = `${SITE_URL}${path || ""}`;
    const robots = noindex ? "noindex, nofollow" : "index, follow";
    const absoluteImage = image?.startsWith("http")
        ? image
        : `${SITE_URL}${image}`;

    return (
        <Helmet>
            <title>{fullTitle}</title>
            <meta name="description" content={description} />
            {keywords && <meta name="keywords" content={keywords} />}
            <meta name="robots" content={robots} />
            <link rel="canonical" href={canonical} />

            <meta property="og:type" content={type} />
            <meta property="og:site_name" content={SITE_NAME} />
            <meta property="og:title" content={fullTitle} />
            <meta property="og:description" content={description} />
            <meta property="og:url" content={canonical} />
            <meta property="og:image" content={absoluteImage} />
            <meta property="og:locale" content="en_US" />

            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:title" content={fullTitle} />
            <meta name="twitter:description" content={description} />
            <meta name="twitter:image" content={absoluteImage} />

            {jsonLd &&
                (Array.isArray(jsonLd) ? jsonLd : [jsonLd]).map((block, i) => (
                    <script key={i} type="application/ld+json">
                        {JSON.stringify(block)}
                    </script>
                ))}
        </Helmet>
    );
};

export default SEO;
